export function isT<T>(option: T | object, optionId: string): option is T {
  return (option as T)[optionId] !== undefined
}
